import Swiper from 'swiper';

$(function () {

    if ( $('#annual-report').length ) {

        /* Top dropdown */
        $(document).click(function() {
            $('#top-dropdown').removeClass('active');
        });
        $('#top-dropdown').on('click', function(e){
            e.stopPropagation();
            $(this).toggleClass('active');
        });

        /* Map and map slider */
        var mapSwiper = new Swiper ('.swiper-container-map', {
            direction: 'horizontal',
            width: 274,
            spaceBetween: 16,
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            slideToClickedSlide: true,
            on: {
                transitionEnd: function() {
                    var active = $('.location-holder .img-slide.swiper-slide-active');
                    var activeLoc = active.attr('data-location');
                    var mapPins = $('.location-holder .map-pin');

                    mapPins.each(function( index ) {
                        $(this).removeClass('active');
                        if ( $(this).attr('data-location') == activeLoc ) {
                            $(this).addClass('active');
                        }
                    });
                }
            }
        });

        $('.location-holder .map-pin').on('click', function(){
            var pinLocation = $(this).attr('data-location');
            $('.location-holder .img-slide').each(function( index ) {
                if (pinLocation == $( this ).attr('data-location')) {
                    mapSwiper.slideTo(index);
                }
            });
        });


        /* Counter */
        function CountdownTracker(label, value){

          var el = document.createElement('span');

          el.className = 'flip-clock__piece';
          el.innerHTML = '<b class="flip-clock__card card"><b class="card__top"></b><b class="card__bottom"></b><b class="card__back"><b class="card__bottom"></b></b></b>' +
            '<span class="flip-clock__slot">' + label + '</span>';

          this.el = el;

          var top = el.querySelector('.card__top'),
              bottom = el.querySelector('.card__bottom'),
              back = el.querySelector('.card__back'),
              backBottom = el.querySelector('.card__back .card__bottom');

          this.update = function(val){
            val = ( '0' + val ).slice(-2);
            if ( val !== this.currentValue ) {

              if ( this.currentValue >= 0 ) {
                back.setAttribute('data-value', this.currentValue);
                bottom.setAttribute('data-value', this.currentValue);
              }
              this.currentValue = val;
              top.innerText = this.currentValue;
              backBottom.setAttribute('data-value', this.currentValue);

              this.el.classList.remove('flip');
              void this.el.offsetWidth;
              this.el.classList.add('flip');
            }
          }

          this.update(value);
        }

        function getTimeRemaining(endtime) {
          var t = Date.parse(endtime) - Date.parse(new Date());
          return {
            'Total': t,
            'Days': Math.floor(t / (1000 * 60 * 60 * 24)),
            'Hours': Math.floor((t / (1000 * 60 * 60)) % 24),
            'Minutes': Math.floor((t / 1000 / 60) % 60),
            'Seconds': Math.floor((t / 1000) % 60)
          };
        }

        function Clock(countdown,callback) {

          countdown = countdown ? new Date(Date.parse(countdown)) : false;
          /* callback = callback || function(){}; */

          var updateFn = countdown ? getTimeRemaining : getTime;

          this.el = document.createElement('div');
          this.el.className = 'flip-clock';

          var trackers = {},
              t = updateFn(countdown),
              key, timeinterval;

          for ( key in t ){
            if ( key === 'Total' ) { continue; }
            trackers[key] = new CountdownTracker(key, t[key]);
            this.el.appendChild(trackers[key].el);
          }

          var i = 0;
          function updateClock() {
            timeinterval = requestAnimationFrame(updateClock);

            // throttle so it's not constantly updating the time.
            if ( i++ % 10 ) { return; }

            var t = updateFn(countdown);
            if ( t.Total < 0 ) {
              cancelAnimationFrame(timeinterval);
              for ( key in trackers ){
                trackers[key].update( 0 );
              }
              callback();
              return;
            }

            for ( key in trackers ){
              trackers[key].update( t[key] );
            }
          }

          setTimeout(updateClock,500);
        }

        var counterEndDate = counter.counter_end_date;
        var counterEndTime = counter.counter_end_time;
        var counterEndCopy = counter.counter_end_copy;

        var deadline = counterEndDate + ' ' + counterEndTime;
        /* var deadline = 'Jan 23 2020 08:58:00'; */
        var c = new Clock(deadline, function(){
            document.getElementById('js-counter-title').innerHTML = counterEndCopy;
            document.getElementById('ticker').style.display = 'none';
        });

        document.getElementById('ticker').appendChild(c.el);

	}

});
